import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgShipping} from "~/assets/svg/shipping.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmShippingIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgShipping id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
